export const BUTTON_THEMES = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  OUTLINED: "outlined",
  TEXT: "text"
};
